module.exports = __webpack_public_path__ + "static/media/SF-3-if-wrong.b18f4e4a.mp3";